module.exports = __webpack_public_path__ + "fonts/museo-sans-900-webfont.2d3815a.ttf";